import { render, staticRenderFns } from "./CardTemplateSharing.vue?vue&type=template&id=485681ec&scoped=true&"
import script from "./CardTemplateSharing.vue?vue&type=script&lang=js&"
export * from "./CardTemplateSharing.vue?vue&type=script&lang=js&"
import style0 from "./CardTemplateSharing.vue?vue&type=style&index=0&id=485681ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485681ec",
  null
  
)

component.options.__file = "CardTemplateSharing.vue"
export default component.exports